var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1515 11.724L21.7213 10.4988L17.9527 2.85879C17.8498 2.64961 17.6804 2.48027 17.4713 2.37734C16.9466 2.11836 16.3091 2.33418 16.0468 2.85879L12.2783 10.4988L3.84801 11.724C3.61559 11.7572 3.40309 11.8668 3.2404 12.0328C3.04371 12.235 2.93532 12.507 2.93906 12.789C2.94279 13.071 3.05834 13.34 3.26032 13.5369L9.35973 19.4836L7.91872 27.8807C7.88493 28.076 7.90654 28.2769 7.98111 28.4606C8.05568 28.6442 8.18023 28.8033 8.34062 28.9198C8.50102 29.0363 8.69085 29.1056 8.88858 29.1197C9.08631 29.1338 9.28404 29.0922 9.45934 28.9996L16.9998 25.0352L24.5402 28.9996C24.7461 29.1092 24.9851 29.1457 25.2142 29.1059C25.792 29.0062 26.1804 28.4584 26.0808 27.8807L24.6398 19.4836L30.7392 13.5369C30.9052 13.3742 31.0148 13.1617 31.048 12.9293C31.1377 12.3482 30.7326 11.8104 30.1515 11.724V11.724Z",
    fill: "#007E8A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.19525898cc2c60d04bd756ad52c4c5c6.svg";
export { ForwardRef as ReactComponent };